import {
	// total week shipment on dashboard
	TOTAL_WEEK_SHIPMENT_LOADING,
	TOTAL_WEEK_SHIPMENT_ERROR,
	TOTAL_WEEK_SHIPMENT_DATA,

	// Get total shipment count based on current year
	TOTAL_YEAR_SHIPMENT_LOADING,
	TOTAL_YEAR_SHIPMENT_ERROR,
	TOTAL_YEAR_SHIPMENT_DATA,

	// Get Today Loading Bookings
	GET_LOADING_BOOKINGS_LOADING_DATA,
	GET_LOADING_BOOKINGS_DATA,
	GET_LOADING_BOOKINGS_ERROR,

	// Get Total Shipment Count based on Current Month
	GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING,
	GET_TOTAL_CURRENT_MONTH_SHIPMENT_ERROR,
	GET_TOTAL_CURRENT_MONTH_SHIPMENT_DATA,

	//get Chart Data based on Bookings and Container
	GET_CHARTS_DATA,
	GET_CHART_DATA_LOADING,
	GET_CHART_DATA_ERROR,
	GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_DATA,
	GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_ERROR,
	GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING,
	GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_DATA,
	GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_ERROR,
	GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING,
	GET_ADVANCED_BOOKING_COUNT_DATA,
	GET_ADVANCED_BOOKING_COUNT_ERROR,
	GET_ADVANCED_BOOKING_COUNT_LOADING,
	SET_SELECTED_TASKS_SCHEDULE
} from './actionTypes';

// total week shipment on dashboard
export const totalWeekShipmentData = data => ({
	type: TOTAL_WEEK_SHIPMENT_DATA,
	payload: data
});

export const totalWeekShipmentLoading = () => ({
	type: TOTAL_WEEK_SHIPMENT_LOADING,
	payload: true
});
export const totalWeekShipmentError = error => ({
	type: TOTAL_WEEK_SHIPMENT_ERROR,
	payload: error
});

// Get Total Shipment Count based on Current Year

export const getTotalShipmentData = data => ({
	type: TOTAL_YEAR_SHIPMENT_DATA,
	payload: data
});

export const getTotalShipmentLoading = data => ({
	type: TOTAL_YEAR_SHIPMENT_LOADING,
	payload: data
});

export const getTotalShipmentError = error => ({
	type: TOTAL_YEAR_SHIPMENT_ERROR,
	payload: error
});

// GET Total Current Month Shipment

export const getTotalCurrentMonthShipmentData = data => ({
	type: GET_TOTAL_CURRENT_MONTH_SHIPMENT_DATA,
	payload: data
});

export const getTotalCurrentMonthShipmentLoading = data => ({
	type: GET_TOTAL_CURRENT_MONTH_SHIPMENT_LOADING,
	payload: data
});

export const getTotalCurrentMonthShipmentError = error => ({
	type: GET_TOTAL_CURRENT_MONTH_SHIPMENT_ERROR,
	payload: error
});

// Get Today Loading Bookings
export const getLoadingBookingsData = data => ({
	type: GET_LOADING_BOOKINGS_DATA,
	payload: data
});

export const getLoadingBookingsLoading = date => ({
	type: GET_LOADING_BOOKINGS_LOADING_DATA,
	payload: date
});
export const getLoadingBookingsError = error => ({
	type: GET_LOADING_BOOKINGS_ERROR,
	payload: error
});

// Get Chart Data based on Bookings and Container
export const getChartsData = data => ({
	type: GET_CHARTS_DATA,
	payload: data
});

export const getChartsDataLoading = (year, chartType) => ({
	type: GET_CHART_DATA_LOADING,
	payload: { year, chartType }
});
export const getChartsDataError = error => ({
	type: GET_CHART_DATA_ERROR,
	payload: error
});

// Get Booking Chart Data Based On Supplier Location
export const getBookingChartDataBasedOnSupplierLocationData = data => ({
	type: GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_DATA,
	payload: data
});

export const getBookingChartDataBasedOnSupplierLocationLoading = month => ({
	type: GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_LOADING,
	payload: month
});
export const getBookingChartDataBasedOnSupplierLocationError = error => ({
	type: GET_BOOKING_CHART_DATA_BASED_ON_SUPPLIER_LOCATION_ERROR,
	payload: error
});

// Get Container Counts Based On Booking Status
export const getContainerCountsBasedOnBookingStatusData = data => ({
	type: GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_DATA,
	payload: data
});

export const getContainerCountsBasedOnBookingStatusLoading = selectedYear => ({
	type: GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_LOADING,
	payload: selectedYear
});

export const getContainerCountsBasedOnBookingStatusError = error => ({
	type: GET_CONTAINER_COUNTS_BASED_ON_BOOKING_STATUS_ERROR,
	payload: error
});

// Get Advanced Booking Count
export const getAdvancedBookingCountData = data => ({
	type: GET_ADVANCED_BOOKING_COUNT_DATA,
	payload: data
});

export const getAdvancedBookingCountLoading = () => ({
	type: GET_ADVANCED_BOOKING_COUNT_LOADING,
	payload: true
});

export const getAdvancedBookingCountError = error => ({
	type: GET_ADVANCED_BOOKING_COUNT_ERROR,
	payload: error
});

export const setSelectedTaskSchedule = data => ({
	type: SET_SELECTED_TASKS_SCHEDULE,
	payload: data
});
